import React, { forwardRef } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

function WithRouter(Component) {
    function ComponentWithRouterProp(props, ref) {
        const navigate = useNavigate();
        const location = useLocation();
        const params = useParams();

        return (
            <Component
                {...props}
                navigate={navigate}
                location={location}
                params={params}
                ref={ref}
            />
        );
    }

    return forwardRef(ComponentWithRouterProp);
}

export default WithRouter;
